module.exports = __webpack_public_path__ + "static/img/gift-16.ecc7f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-16.png
// module id = 360
// module chunks = 140